import { FC } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export interface MetaComponentProps {
  meta: {
    title:string;
    description:string;
  }
}

const MetaComponent:FC<MetaComponentProps> = (props) => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>{props.meta.title}</title>
        <meta name="description" content={props.meta.description} />
      </Helmet>
    </HelmetProvider>
  );
}

export default MetaComponent;